<!-- Shared single-file zone-document upload dialog with inline preview. -->
<div class="documents-dialog">
  <div
    class="documents-dialog__background"
    data-testid="zone-doc-upload-backdrop"
    (click)="onCancel()"
  ></div>
  <div class="documents-dialog__content zone-upload-dialog">
    <button
      type="button"
      class="documents-dialog__content__close"
      data-testid="zone-doc-upload-close"
      (click)="onCancel()"
    >
      <span class="material-icons">close</span>Close
    </button>
    <h2 class="zone-upload-dialog__title">Upload Document</h2>

    <!-- Drop zone (drag-drop + click-to-browse), single file -->
    <div
      class="zone-upload-dialog__dropzone"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <label
        for="zone-doc-file-upload"
        class="zone-upload-dialog__dropzone-label"
      >
        <span class="material-icons">upload_file</span>
        <span *ngIf="!file"
          >Drag &amp; drop a file here, or click to browse</span
        >
        <span *ngIf="file">{{ file.name }} — click to replace</span>
      </label>
      <input
        id="zone-doc-file-upload"
        type="file"
        data-testid="zone-doc-upload-file-input"
        (change)="onFileSelect($event)"
        accept=".pdf, .txt, .csv, .gif, .png, .tiff, .jpg, .doc, .docx, .xls, .xlsx, .html, .zip"
      />
    </div>

    <!-- Inline preview + shared coverage form, side by side -->
    <div class="zone-upload-dialog__body">
      <div class="zone-upload-dialog__preview">
        <ng-container *ngIf="file; else noFilePreview">
          <iframe
            *ngIf="isPdf && previewUrl; else fileChip"
            class="zone-upload-dialog__preview-frame"
            [src]="previewUrl"
            title="Document preview"
          ></iframe>
          <ng-template #fileChip>
            <div class="zone-upload-dialog__file-chip">
              <span class="material-icons">insert_drive_file</span>
              <span class="zone-upload-dialog__file-chip-name">{{
                file.name
              }}</span>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #noFilePreview>
          <div class="zone-upload-dialog__preview-empty">
            <span class="material-icons">visibility</span>
            <p>Select a file to preview it here.</p>
          </div>
        </ng-template>
        <p class="zone-upload-dialog__preview-hint">
          Preview is available for PDF files only.
        </p>
      </div>

      <div class="zone-upload-dialog__form">
        <zone-doc-coverage-form
          [service]="service"
          [scopedSubType]="scopedSubType"
          [siblingSubTypes]="siblings"
          [initialExpiration]="''"
          [initialIssueDate]="''"
          [licenseDriven]="!!license"
          [expirationDateRequired]="expirationRequired"
          [issueDateRequired]="issueRequired"
          [licenseRequirementId]="license?.id ?? null"
          (coverageChange)="onCoverageChange($event)"
        ></zone-doc-coverage-form>
      </div>
    </div>

    <!-- Footer: zone + service context + Cancel / Save -->
    <div class="documents-dialog__content__footer zone-upload-dialog__footer">
      <div class="zone-upload-dialog__footer-context">
        <div class="documents-dialog__content__footer__service-type">
          <p class="documents-dialog__content__footer__service-type__label">
            Zone
          </p>
          <p class="documents-dialog__content__footer__service-type__text">
            {{ zoneLabel }}
          </p>
        </div>
        <div
          class="documents-dialog__content__footer__service-type"
          *ngIf="serviceLabel"
        >
          <p class="documents-dialog__content__footer__service-type__label">
            Service
          </p>
          <p class="documents-dialog__content__footer__service-type__text">
            {{ serviceLabel }}
          </p>
        </div>
        <div
          class="documents-dialog__content__footer__service-type"
          *ngIf="license?.documentTitle"
        >
          <p class="documents-dialog__content__footer__service-type__label">
            Requirement
          </p>
          <p class="documents-dialog__content__footer__service-type__text">
            {{ license.documentTitle }}
          </p>
        </div>
      </div>
      <div class="zone-upload-dialog__footer-actions">
        <button
          type="button"
          class="doc-btn zone-upload-dialog__cancel"
          data-testid="zone-doc-upload-cancel"
          (click)="onCancel()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="doc-btn doc-btn--primary"
          data-testid="zone-doc-upload-save"
          [disabled]="!canSave"
          (click)="onSave()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
